/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */
@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.model

import io.kvision.types.LocalDate
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization

@Serializable
data class PostCodeList(
  val postCodeSugList: ArrayList<PostCodeSug>,
)

@Serializable
data class PostCodeSug(
  val postCode: String?,
  val cityNo: String?,
  val voivodeship: String?,
  val district: String?,
  val commune: String?,
  val town: String?,
  val street: String?,
  val postOffice: String?,
  val simc: String?
)

@Serializable
data class PostOfficeSug(
  val postOffice: String?,
  val postCode: String?,
  val street: String?,
  val town: String?,
  val simc: String?,
  val voivodeship: String?,
  val district: String?,
  val commune: String?
)

@Serializable
data class StreetSug(
  val streetName: String?,
  val streetId: String?
)